import { getLogMessage } from './utils';
import { datadogLogs } from '@datadog/browser-logs';
/**
 * A transport that sends logs to Datadog.
 * Note: This requires the datadog reporter to be initialized for it to work.
 */
export function datadogTransport(config = {}) {
    const transport = {
        ...config,
        log: ({ level, message, ...metadata }) => {
            // Datadog expects a string message.
            datadogLogs.logger[level](getLogMessage(message), metadata);
        },
    };
    return transport;
}
//# sourceMappingURL=datadogTransport.js.map